<template>
    <!-- 
        Quick-fetching-card

        Props: 
			fetchingAPI: (Opcional, Default inherit)
				URL for table/data fetching

			header: (Opcional, Default inherit)
				Header title

			footer: (Opcional, Default empty)
				Footer content text

        Version 1.4
        Convention simplification

        Version 1.3j
        Naming simplification.

        Version 1.2
        It can be configured with props.

        Version 1.1
        Require jquery to ensure loading in case of F5

        Version 1.0
        Quick fetching card allow you to a fast setting up for any kind of content with data preload.
        
        @Version 1.0
        @Author Daniel Lepe
        -->
	<div :id="name">

		<b-card no-body>

            <template v-slot:header>
				
				<b-row align-h="between">
					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{header}}</h6>
					</b-col>

					<b-col>
						<div tabindex="-1" role="group">
							<div role="group" class="input-group">
                                <input type="text" v-model="term" @keyup.enter="reload()" placeholder="Buscador..." class="form-control" />
								<div class="input-group-append">
									<button v-if="!!term" type="button" class="btn btn-secondary" @click="term = ''; reload();">
										<i class="fa fa-times"></i>
									</button>
									<button type="button" class="btn btn-secondary" @click="reload()" :disabled="!term">
										<i class="fa fa-search"></i>
									</button>
								</div>
							</div>
						</div>
					</b-col>

					<b-col md="auto" class="align-right">
						<ui-edit-auto-modal dele key="new" v-model="form" :refresh="reload" :formArchetype="formArchetype" ref="main" :label="newButtonLabel" handler="define/source/nextbanners" apply-button="Aplicar" size="md" :allowDelete="false"/>
					</b-col>
				</b-row>

			</template>

			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

            <div v-else-if="!items.length" class="pt-4 pl-4 pr-4  pb-0">
                <b-jumbotron :header="emptyHeader" :lead="emptyLead">
                    <p>Intenta mas tarde</p>
                    <b-button variant="primary" @click="reload()">Volver a cargar los datos</b-button>
                </b-jumbotron>
            </div>

			<b-table v-else class="animated fadeIn" responsive :items="items" :fields="captions">

				<template #cell(imagen)="data">
					<img-portal :src="data.value" />
				</template>

				<template #cell(_)="data">
					<ui-edit-auto-modal label="Ver" :view-only="false" size="md" v-model="form"  :handler="'define/source/nextbanners/' + data.item.id" :form-archetype="formArchetype" :refresh="reload" />
				</template>

			</b-table>

			<template v-slot:footer v-if="!isLoading && items.length">
				<b-row>
					<b-col>
						<p class="text-center p-0 m-0 mt-1">
							<strong>Página {{currentPage}} de {{Math.ceil(itemsCount / perPage)}}</strong> (Se muestran
							<strong>{{items.length}} registros</strong>
							de un total de {{itemsCount}})
						</p>
					</b-col>
					<b-col>
						<b-pagination class="p-0 m-0" v-model="currentPage" :total-rows="itemsCount" :per-page="perPage" align="center" prev-text="Anterior" next-text="Siguiente" />
					</b-col>
					<b-col cols="1">
						<b-card-text class="text-right">
							<b-button @click="reload()" variant="outline-primary" key="fa-refresh">
								<i class="fa fa-refresh" aria-hidden="true"></i>
							</b-button>
						</b-card-text>
					</b-col>
				</b-row>
			</template>
		</b-card>

	</div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

let name = "NextbannersMainCard",
    newButtonLabel = 'Nuevo',
    emptyHeader = 'Datos no encontrados',
    emptyLead =  'Éste módulo está actualmente vacíos',
	fetchedData = {},
	header = '',
	footer = null,
	fieldsConfg = [
		{key: 'imagen'},
		{key: 'titulo'},
		{key: 'estatus'},
		{key: 'posicion_ascendente', label: 'Posición en la lista'},
		{key: '_'}
	],
	fetchingAPI = 'origins/banners';

export default {
	name,

	props: {
		fetchingAPI: {
			type: String,
			default: () => { return fetchingAPI }
		},
		header: {
			type: String,
			default: () => { return header }
		},
		perPage: {
			type: Number,
			default: 20,
		},
		footer: {
			type: String,
			default: () => { return footer }
		}
	},
	
	computed: {
		formArchetype () {
			return [
				{
					key: "id",
					type: 'hidden', // [hidden|number|price|phone|textarea|positivo|password|email]
				},
				{
					key: "imagen",
					label: 'Imágen. (1618px / 700px) recomendado',
					type: 'storedimg'
				},
				{
					key: 'titulo',
					label: 'Título local del banner. (Los usuarios no lo verán)'
				},
				{
					key: 'estatus',
					type: 'select',
					options: ['Disponible', 'Oculto']
				},
				null,
				{
					key: 'disp_landing',
					label :'Disponible en landing',
					default: 1,
					type: 'checkbox'
				},
				{
					key: 'disp_tienda',
					label :'Disponible en tienda',
					default: 1,
					type: 'checkbox'
				},
				{
					key: 'disp_alimentos',
					label :'Disponible en alimentos',
					default: 1,
					type: 'checkbox'
				},
				{
					key: 'disp_recetas',
					label :'Disponible en recetas',
					default: 1,
					type: 'checkbox'
				},
				{
					key: 'disp_menu',
					label :'Disponible en menús',
					default: 1,
					type: 'checkbox'
				},
				{
					key: 'disp_easyfood',
					label :'Disponible en EasyFood',
					default: 1,
					type: 'checkbox'
				},
				null,
				{
					key: 'posicion_ascendente',
					label :'Posición descendnete',
					type: 'select',
					options: (() => {
						let r = [], text = '';
						for(let value = 1; value <= 10; value++){
							switch(value){
								case 1:
									text = 'Primero en la lista';
									break;
								case 10:
									text = 'Último en la lista';
									break;
								default:
									text = `${value}° en la lista`
									break;
							}
							r.push({
								value,
								text
							})
						}
						return r
					})()
				},
				null,
				[
					{
						key: 'url_tipo',
						label: 'Configuración de la liga',
						type: 'select',
						options: ("Inactiva, Página externa").split(', '),
						default: "Inactiva"
					},
					{
						key: 'url',
						label: 'Liga (Empieza con: https:// )',
						readonly: !this.tools.allowURL
					}
				]
			]
		},
		sourceURI() {
			let init = this.fetchingAPI + "/" + this.perPage + "/" + this.currentPage;
			if (!!this.term) {
				init += "/" + this.term;
			} else if (!this.term || this.term == "s") {
				init += "/@";
			}
			return init;
		},
		captions: function () {
			return this.fieldsConfg;
		},
		newItem() {
			return {
				name: this.newItemName,
			};
		}
	},
	
	data: () => {
		return {
			name, newButtonLabel, emptyHeader,
            emptyLead,
			form: {
				id: null
			},
			tools: {
				allowURL: true
			},
			isEditing: false,
			currentPage: 1,
			items: [],
			itemsCount: 0,
			term: null,
			isLoading: false,
			fieldsConfg,
			fetchedData,
			asides: {
				recargaAmount: 0,
				ofertaspublicas: []
			}
		}
	},
	
	methods: {
		async reload(){
			this.isLoading = true
			await this.loadUp()
			this.isLoading = false
		},
		async loadUp(){
			try {
				let response = await axios.get(this.sourceURI)
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.loading = false;
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				// this.fetchedData = response.data
			} catch (error) {
				console.error(error)
			}
		}
	},

	watch: {
		'form.id'(){
			if(this.form.id){
				this.isEditing = true;
			} else {
				this.isEditing = false;
			}
		},
		'form.url_tipo'(){
			switch(this.form.url_tipo){
				case 'Inactiva':
					this.tools.allowURL = false
					break;
				case 'Página externa':
					this.tools.allowURL = true;
					break;
			}
		},
		currentPage(a, b) {
			this.reload();
		},
		'$route'(){
			this.loadUp()
		}
	},

	mounted() {
		this.reload()
	}
};
</script>

<style lang="less" scoped>
    .api-img {
        width: 7em;
        height: 7em;
    }
</style>